module.exports = __webpack_public_path__ + "img/Witnessing_Desktop.jpg";